import { createAction, props } from '@ngrx/store';
import {
	AdminRootResource,
	UnprocessableEntityError,
	UnterscheidungssignalListResource,
	UnterscheidungssignalResource,
} from './admin.model';

const PREFIX = '[Admin] ';

export const loadAdminRootAction = createAction(PREFIX + 'Load Admin Root');

export const loadAdminRootSuccessAction = createAction(
	PREFIX + 'Load Admin Root Success',
	props<{
		adminRoot: AdminRootResource;
	}>()
);

export const loadUSignaleAction = createAction(PREFIX + 'Load U-Signale');

export const loadUSignaleSuccessAction = createAction(
	PREFIX + 'Load U-Signale Success',
	props<{
		uSignale: UnterscheidungssignalListResource;
	}>()
);

export const uploadUSignaleAction = createAction(
	PREFIX + 'Upload U-Signale',
	props<{
		file: File;
	}>()
);

export const saveUsignalErrorAction = createAction(
	PREFIX + 'Save U-Signal Error',
	props<{
		error: UnprocessableEntityError;
	}>()
);

export const clearUSignalErrorAction = createAction(PREFIX + 'Clear U-Signal Error');

export const askToDeleteUSignalAction = createAction(
	PREFIX + 'Ask To Delete U-Signal',
	props<{
		uSignal: UnterscheidungssignalResource;
	}>()
);

export const deleteUSignalAction = createAction(
	PREFIX + 'Delete U-Signal',
	props<{
		uSignal: UnterscheidungssignalResource;
	}>()
);
